import TagManager from 'react-gtm-module';
import urlHasLanguage from './urlHasLanguage';

export enum gtmCategories {
  cashOut = 'Cash Out',
  registration = 'RegilyJoin',
  deposit = 'Deposit',
  betting = 'Betting',
  navigation = 'Navigation',
  user = 'User',
  userProfile = 'User profile',
  search = 'Search',
  withdraw = 'Withdraw',
  internalPromotions = 'Internal promotions',
  ecommerce = 'Ecommerce',
  setLimits = 'Set limits',
}

export enum gtmEvents {
  ga = 'GA',
  pageView = 'PageView',
  mybetEventListClick = 'MybetEventListClick',
}
type gtmEvent = keyof typeof gtmEvents;
type gtmCategory = keyof typeof gtmCategories;

export type TrackingObject = {
  event: gtmEvent | string;
  action?: string;
  category: gtmCategory | string;
  label?: string;
  value?: string | number;
  path?: string;
  user?: string;
  paymentType?: string;
  sms?: boolean;
  email?: boolean;
};
// TODO: update imports of gtm tracking object and types to be from here and not random strings for events and categories

export const trackGTM = async (
  trackingObject: TrackingObject,
  language?: string
): Promise<void> => {
  if (trackingObject.label && language) {
    trackingObject.label = urlHasLanguage(trackingObject.label, language);
  }

  // I had this issue at least tracking RegilyJoin event
  // To avoid having this issue somewhere else I would prefer to fix it globally
  // Providing these fields for the events without them
  if (trackingObject.event === gtmEvents.ga) {
    trackingObject = {
      label: undefined,
      path: undefined,
      ...trackingObject,
    };
  }

  if (process.env.INITIALISE_GTM === 'true') {
    TagManager.dataLayer({
      dataLayerName: 'dataLayer',
      dataLayer:
        trackingObject.event === gtmEvents.pageView
          ? {
              event: trackingObject.event,
              path: trackingObject.path,
            }
          : trackingObject,
    });
  }
};

export default trackGTM;
